<main class="tracking" *ngIf="oldStatus">
  <h5 class="tracking--title">{{ 'stateTitle' | i18next }}</h5>
  <table class="table table-responsive" *ngIf="oldStatus.length > 0">
    <thead>
      <th>{{ 'altUser' | i18next }}</th>
      <th>{{ 'state' | i18next }}</th>
      <th>{{ 'documentationTableDate' | i18next }}</th>
    </thead>
    <tbody>
      <ng-container *ngFor="let state of oldStatus">
        <tr>
          <td>{{ state.actor }}</td>
          <td>
            {{ this.translate.translateRequestStatus(state.requestStatus) }}
          </td>
          <p>{{ state.date | date: 'short' }}</p>
        </tr>
      </ng-container>
    </tbody>
  </table>
  <table class="table table-responsive" *ngIf="oldStatus.length === 0">
    <p>{{ 'landingNoVehicles' | i18next }}</p>
  </table>
</main>
